export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/angle-left.c9027dcc.svg","height":28,"width":13};